module.exports = __webpack_public_path__ + "assets/img/nttdata_bianco.47668dd2.png";